import { WEB_BASE } from "@/lib/api";

const seen = new Set();
export function reportError(err, source = "window") {
  try {
    const message = String(err?.message || err || "Unknown error").slice(0, 500);
    const key = `${source}:${message}`;
    if (seen.has(key) || seen.size > 20) return;
    seen.add(key);
    const body = JSON.stringify({ message, stack: String(err?.stack || "").slice(0, 2000), source, url: window.location.href, ua: navigator.userAgent, at: new Date().toISOString() });
    if (navigator.sendBeacon) navigator.sendBeacon(`${WEB_BASE}/api/client-errors`, new Blob([body], { type: "application/json" }));
    else fetch(`${WEB_BASE}/api/client-errors`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch {}
}

export function installErrorReporting() {
  window.addEventListener("error", (e) => { if (e.error) reportError(e.error, "window"); else if (e.message) reportError(e.message, "window"); });
  window.addEventListener("unhandledrejection", (e) => reportError(e.reason, "promise"));
}
